export function stringToInitials(str: string, splitter = ' ', initialsCount = 2): string {
  const splitString = str.split(splitter).filter(Boolean);
  return splitString
    .slice(0, initialsCount)
    .map((word) => word[0] ?? '')
    .join('');
}
